import { errorHandler } from '@/lib/utils/error-handler';
import { useQuery } from '@tanstack/react-query';
import { formatEther } from 'viem';
import { useChainId, usePublicClient } from 'wagmi';

export const useBalance = (address: `0x${string}` | undefined) => {
  const chainId = useChainId();
  const publicClient = usePublicClient({ chainId });
  const balance = useQuery({
    queryKey: ['/blockchain/balance', address, chainId],
    queryFn: async () => {
      try {
        if (!address) throw new Error('Address is required.');
        if (!publicClient) throw new Error('Public client is required.');
        const balance = await publicClient.getBalance({
          address,
        });
        return { balance: Number(formatEther(balance)), chain: publicClient.chain };
      } catch (e: any) {
        errorHandler(e);
      }
    },
    enabled: Boolean(address && publicClient && chainId),
    refetchInterval: 12000,
    staleTime: 12000,
  });
  return { balance };
};
